import './App.css';
import {Home} from "./pages/Home";
import {Unsubscribe} from "./pages/Unsubscribe";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
        <Routes>
            <Route path="/:id" element={<Home />} />
            <Route path="unsubscribe/:id" element={<Unsubscribe />} />
        </Routes>
    </Router>
  );
}

export default App;
